export const availableFonts = [
  {
    name: 'Helvetica',
    value: 'helvetica, sans-serif',
  },
  {
    name: 'Arial',
    value: 'arial, sans-serif',
  },
  {
    name: 'Verdana',
    value: 'verdana, sans-serif',
  },
  {
    name: 'Tahoma',
    value: 'Tahoma, sans-serif',
  },
  {
    name: 'Trebuchet MS',
    value: 'trebuchet ms, sans-serif',
  },
  {
    name: 'Monaco',
    value: 'monaco, monospace',
  },
  {
    name: 'Gill Sans',
    value: 'gill sans, sans-serif',
  },
  {
    name: 'Times New Roman',
    value: 'times new roman, serif',
  },
  {
    name: 'Andalé Mono',
    value: 'andale mono, monospace',
  },
];
